import React from 'react';
import PropTypes from 'prop-types';

import RecipeListItem from './RecipeListItem';
import HorizontalScrollList from '../../../catalogue/components/HorizontalScrollList';

const RecipesList = ({ recipes }) => {
  if (!recipes || !recipes.length) {
    return null;
  }

  return (
    <>
      <h3 className="bop-recipes__title">Recipes</h3>
      <div className="bop-recipes__wrapper">
        <HorizontalScrollList
          mainClassName="bop-recipes"
          arrowLeft={<span className="icon icon__chevron-left" />}
          arrowRight={<span className="icon icon__chevron-right" />}
        >
          {
            recipes.map(recipe => <RecipeListItem key={recipe.id} {...recipe} />)
          }
        </HorizontalScrollList>
      </div>
    </>
  );
};

RecipesList.propTypes = {
  recipes: PropTypes.array,
};

export default RecipesList;
